// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"fc577125","161":"97cd4ef2","411":"34575d61","643":"a89a2d2a"}[chunkId] + ".chunk.css";
};